import { createRoot } from 'react-dom/client'
import './index.css'
import { BrowserRouter } from "react-router";
import ScaenaRouter from './utils/Routes.tsx';
import { HelmetProvider } from 'react-helmet-async';
createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
  <BrowserRouter>
   <ScaenaRouter></ScaenaRouter>
  </BrowserRouter>    
  </HelmetProvider>
,
)
